import { ref } from "vue";
import { translate } from "@/composables/translate";

export default function useLanguageProficiency() {

    let proficiencyList = ref([
        { id: 1, title: translate("native", "ucfirst") },
        { id: 2, title: 'A1 ' + translate("beginner", "ucfirst") },
        { id: 3, title: 'A2 ' + translate("basic", "ucfirst") },
        { id: 4, title: 'B1 ' + translate("intermediate", "ucfirst") },
        { id: 5, title: 'B2 ' + translate("upper intermediate", "ucfirst") },
        { id: 6, title: 'C1 ' + translate("advanced", "ucfirst") },
        { id: 7, title: 'C2 ' + translate("proficient", "ucfirst") }
    ]);

    function singleProficiency(id = 0) {
        for (let i = 0; i < proficiencyList.value.length; i++) {
            if (proficiencyList.value[i].id == id) {
                return proficiencyList.value[i]
            }
        }
    }

    return {
        proficiencyList,
        singleProficiency
    };
}
